import {OUTSOURCE_ERROR, OUTSOURCE_UPDATE} from "../actions/outsourceActions";
import {
  EXPORT_DOCUMENTS_CLEAR,
  EXPORT_DOCUMENTS_LOADING,
  EXPORT_OUTSOURCE_LINKED_DOCUMENT,
  EXPORT_OUTSOURCE_MACHINE_DOCUMENT, EXPORT_OUTSOURCE_MONTHLY_DOCUMENT,
  EXPORT_OUTSOURCE_OUTSOURCE_DOCUMENT,
  EXPORT_OUTSOURCE_WORKER_DOCUMENT
} from "../actions/exportOutsourceDocsActions";

const INITIAL_STATE = {
  outsource: null,
  outsourceError: null,

  loading: false,

  outsourceDocuments: [],
  workers: [],
  machines: [],
  monthlyDocuments: [],
  linkedDocuments: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OUTSOURCE_UPDATE:
      return {
        ...state,
        outsource: action.payload.data,
        outsourceError: null,
      };
    case OUTSOURCE_ERROR:
      return {
        ...state,
        outsource: null,
        outsourceError: action.payload,
      };

    case EXPORT_DOCUMENTS_LOADING:
      return { ...state, loading: action.payload };

    case EXPORT_DOCUMENTS_CLEAR:
      return { ...state, ...INITIAL_STATE };

    case EXPORT_OUTSOURCE_OUTSOURCE_DOCUMENT:
      let newOutsourceDocuments = [];
      if (action.checked) {
        newOutsourceDocuments = addElement(state.outsourceDocuments, action.payload)
      } else {
        newOutsourceDocuments = removeElement(state.outsourceDocuments, action.payload)
      }
      return {
        ...state,
        outsourceDocuments: newOutsourceDocuments,
      };
    case EXPORT_OUTSOURCE_WORKER_DOCUMENT:
      let newWorkers = [];
      if (action.checked) {
        newWorkers = addElement(state.workers, action.payload)
      } else {
        newWorkers = removeElement(state.workers, action.payload)
      }
      return {
        ...state,
        workers: newWorkers,
      };
    case EXPORT_OUTSOURCE_MACHINE_DOCUMENT:
      let newMachines = [];
      if (action.checked) {
        newMachines = addElement(state.machines, action.payload)
      } else {
        newMachines = removeElement(state.machines, action.payload)
      }
      return {
        ...state,
        machines: newMachines,
      };
    case EXPORT_OUTSOURCE_MONTHLY_DOCUMENT:
      let newMonthlyDocuments = [];
      if (action.checked) {
        newMonthlyDocuments = addElement(state.monthlyDocuments, action.payload)
      } else {
        newMonthlyDocuments = removeElement(state.monthlyDocuments, action.payload)
      }
      return {
        ...state,
        monthlyDocuments: newMonthlyDocuments,
      };
    case EXPORT_OUTSOURCE_LINKED_DOCUMENT:
      let newLinkedDocuments = [];
      if (action.checked) {
        newLinkedDocuments = addElement(state.linkedDocuments, action.payload)
      } else {
        newLinkedDocuments = removeElement(state.linkedDocuments, action.payload)
      }
      return {
        ...state,
        linkedDocuments: newLinkedDocuments,
      };

    default:
      return state;
  }
};

function addElement(array, element) {
  return [...array, element]
}

function removeElement(array, element) {
  let newArray = [...array];
  return newArray.filter(ele => ele.id !== element.id);
}


// WEBPACK FOOTER //
// ./src/app/outsource/reducers/ExportOutsourceDocsReducer.js